import classNames from "classnames";
import { ReDocTrober } from "src/UI";
import './content-container.scss';

interface IContentContainerProps extends React.HTMLAttributes<HTMLDivElement> {
	children?: React.ReactNode
	fluid?: boolean;
	isLoading: boolean;
	/** Рисовать контент внезависимости от лоудера */
	isRenderContentWhenLoading?: boolean;
	renderSubMenu?: React.FC;
	renderContent?: React.FC;
};

/** Контейнерная компонента с подменю и лоудером */
const ContentContainer: React.FC<IContentContainerProps> = ({ isLoading, isRenderContentWhenLoading = false, fluid = true, children, renderSubMenu, renderContent, className, ...otherProps}) => {

	const classes = classNames('rdc_content-container', className, { 'rdc-fluid': fluid });

	if ( isLoading && !isRenderContentWhenLoading ) {
		return (
			<div className={classes}>
				<ReDocTrober size='xl' className='m-auto'/>
			</div>
		);
	}

	return (
		<div className={classes}>
			{ isLoading && <ReDocTrober size='xl' className='m-auto'/> }
			{ !!renderSubMenu && renderSubMenu( {...otherProps}) }
			{ !!children && children }
			{ !!renderContent && renderContent(otherProps) }
		</div>
	);
};

export default ContentContainer;